// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';
import LRU from 'lru-cache';

type CatalogResponse = { merchant_id: Number };

const cache = LRU({ max: 10 });

export const getClientCatalogs = wrapWithNetworkError(
  (token: string, clientId: Id) => {
    // check cache
    if (cache.has(clientId)) {
      const data = cache.get(clientId);
      if (data) return Promise.resolve(data);
    }

    // This was changed from '/merchantGroup/{clientId}/merchant'. The new
    // endpoint should return all the same information as the old endpoint,
    // plus additional data regarding social collection.  If a bug is
    // discovered in this new endpoint or it is changed in a way that causes
    // it to take a while to return, we may need to revert.
    const fetchUrl = getEndpointUrl(`/socialcollection/client/${clientId}`);
    const fetchOptions = {
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        Authorization: token,
      },
    };

    return fetch(fetchUrl, fetchOptions)
      .then(response => checkResponse(response))
      .then(response => response.json())
      .then(_response => {
        const response = _response.map(merchantIdToCatalogId);
        cache.set(clientId, response);
        return response;
      });
  }
);

function merchantIdToCatalogId(item: CatalogResponse) {
  const { merchant_id: catalog_id, ...rest } = item;

  return {
    catalog_id,
    ...rest,
  };
}



// WEBPACK FOOTER //
// ./src/containers/client/catalogApi.js